import { render, staticRenderFns } from "./injuryhandleDetail.vue?vue&type=template&id=2d4ec466&"
import script from "./injuryhandleDetail.vue?vue&type=script&lang=js&"
export * from "./injuryhandleDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports